import styled from 'styled-components';
import {CenteredDivWrap} from '../../../CommonStyleUtils/dwebCommon.styles';
import Image from '@stencil/image';

export const WrapperDiv = styled(CenteredDivWrap)(
  props => `
  width: ${props.size ? props.size : '5rem'};
  height: ${props.size ? props.size : '5rem'};
  border-radius: 50%;
  position: relative;
  background-color: ${props.theme.colors.downriver.light};
`,
);

export const TextStyles = styled.span(
  props => `
  color: ${props.theme.colors.downriver.dark};
  font-size: ${props.size ? `calc(${props.size}/2)` : props.theme.font.custom(16)};
  text-transform: uppercase;
`,
);

export const ImgStyles = styled(Image)(
  props => `
  width: ${props.size ? props.size : '5rem'};
  height: ${props.size ? props.size : '5rem'};
  border-radius: 50%;
`,
);
